import { render } from "./linkRole.vue?vue&type=template&id=034e7b4e&scoped=true"
import script from "./linkRole.vue?vue&type=script&lang=js"
export * from "./linkRole.vue?vue&type=script&lang=js"

import "./linkRole.vue?vue&type=style&index=0&id=034e7b4e&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034e7b4e"]])

export default __exports__